export default __webpack_public_path__ + "static/media/icon_cat_MensBands.1e0401ba.png";